import _curry2 from "./internal/_curry2.js";
import paths from "./paths.js";
var path = _curry2(function path(pathAr, obj) {
    return paths([pathAr], obj)[0];
});
export default path;
